<template>
  <div>


    <div class="md:flex md:items-center md:justify-between bg-white">
      <div class="min-w-0 flex-1 text-left pl-8">
        <h1 class="mt-3 text-1xl font-extrabold tracking-tight text-cyan-800">
          {{ tipoMedicion }}  
        </h1>
      </div>
      <div class="min-w-0 flex-1 text-left pl-0">
        <AlertDummy v-show="this.glosaDataTypeNatural !== ''" :glosa="glosaDataTypeNatural"></AlertDummy>
      </div>
      <div class="min-w-0 flex-1 text-left pl-0">
        <AlertDummy v-show="this.glosaDataTypeOxigenado !== ''" :glosa="glosaDataTypeOxigenado"></AlertDummy>

      </div>
      <div class="mt-4 flex md:mt-0 md:ml-4">
        {{ labelErr }}
        <span class="isolate inline-flex rounded-md shadow-sm p-3">
       
        </span>
        <span class="isolate inline-flex rounded-md shadow-sm ml-12 p-3">
        <!--   <button v-show="this.spinner == false" type="button" @click="loadMapa(propIdFaena)"
            class="relative inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500">
            {{ $t('mapa') }}
          </button> -->
          <button v-show="this.spinner == false" type="button" @click="showModalHelp()"
            class="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-1 focus:ring-indigo-500">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" class="w-8 h-8">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M11.25 11.25l.041-.02a.75.75 0 011.063.852l-.708 2.836a.75.75 0 001.063.853l.041-.021M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9-3.75h.008v.008H12V8.25z" />
            </svg>
          </button>
        </span>
      </div>
    </div>
    <div class="bg-white shadow-lg">

      <!--  {{ this.valorMinY0  }} - {{ this.valorMaxY0  }}-->
      <textarea style="color:red" id="adjustable-textarea" row="100" class="w-full  p-2 border border-gray-300 rounded
         text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 hidden" v-model="this.fs"> </textarea>

      <textarea style="color:rebeccapurple" id="adjustable-textarea" row="100" class="w-full  p-2 border border-gray-300 rounded
         text-xs focus:outline-none focus:ring-2 focus:ring-blue-500  hidden" v-model="this.fs2"> </textarea>
 
      <SpinnerLoading v-show="this.spinner"></SpinnerLoading>
      <highcharts v-if="!this.mostrarSpinner" :constructor-type="'stockChart'" :options="chartOptions"></highcharts>
    </div>
  </div>
</template>
<script>
//import axios from "axios";

import { Chart } from "highcharts-vue";
import Highcharts from "highcharts";

//import stockInit from 'highcharts/es-modules/Stock'
import stockInit from "highcharts/modules/stock";

import SpinnerLoading from "../SpinnerLoading"
import AlertDummy from "../AlertDummy.vue";
import i18n from '@/i18n';
stockInit(Highcharts);
 

export default {
  components: {
    highcharts: Chart,
    SpinnerLoading: SpinnerLoading,
    AlertDummy: AlertDummy

  },
  emits: ["loadMapa",
    "loadMultiplesUnidades"],
  props: [
    "seriesMedicionesOrpOzonizado",
    "seriesMedicionesOrpNatural",
    "idMedicion",
 
    "mostrarSpinner",
    "glosaDataTypeOxigenado",
    "glosaDataTypeNatural",
    "propIdFaena"
  ],

  data() {
    return {
   lang_eng: {
        months: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        weekdays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      },

      lang_esp: {
        months: [
          "Ene",
          "Feb",
          "Mar",
          "Abr",
          "May",
          "Jun",
          "Jul",
          "Ago",
          "Sep",
          "Oct",
          "Nov",
          "Dic",
        ],
        weekdays: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
      },
      spinner: true,
      fs: '',
      fs2: '',
      seriesMedicionesLocal: [],
      labelErr: '',
      natural: false,
      oxigenado: false,
      idTipo: 2,
      nombreIdTipoMedicion: "",
      mediciones: [],
      showModal: false,
      Centro2: [],
      minY: 0,
      maxY: 25,
      tieneMediciones: false,
      valorMaxY0: 0,
      valorMinY0: 0,
      arrayAllVal: [],
      chartOptions:
      {
        chart: {
          type: 'spline'
        },
        colors: ['#FF6E00', '#7CB5EC', 
        "#0C00CA",
          "#FFBF00",
          "#BF008F",
          "#5A00B4",
          "#00D563",
          "#669966",
          "#303200",
          "#A30099",
          "#CC3366",
          "#CC33FF",
          "#660000",
          "#99CCCC",
          "#CC00FF",
        //'#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC', '#7CB5EC'
         ],
        events: {
          load: function () {

          },
        },
        tooltip: {


        },
        legend: {
          enabled: true,

          layout: "vertical",
          align: "right",
          verticalAlign: "top",
        },
        plotOptions: {


          series: {
            showInNavigator: true,

          },
        },
        xAxis: {
          showLastLabel: true,
        },
        yAxis: {
          opposite: false,
          title: {
            text: 'mg/l',
          },
          formatter: function (val) {
            return val.toFixed(2);
          },
    
          max: 0,
          min: 70,

        },
        series: [
          {
            name: '', // Nombre de la primera serie
            data: [], // Datos para la primera serie
            yAxis: 0, // Indica que esta serie usa el primer eje Y (el izquierdo),
            zones: [],
            zoneAxis: 'x',
            marker: {
              enabled: false,
            }
          }
        ],
        navigator: {
          series: {
            lineWidth: 2,
            fillOpacity: 0.04,
            dataGrouping: {
              smoothed: false,
            },
          },
        },
        rangeSelector: {
          selected: 2,
          floating: true,
          y: 400,
        },
        title: {
          text: "",
        },


      },
    };
  },
  watch: {
    // seriesMediciones['',[ obj_faena_natural ],  [obj_faena_oxigenado]]->   [ { obj_faena } ] - > obj_faena.data[] -> array_datos_diarios 
    mostrarSpinner: function () {
      this.chartOptions.series = [];
      this.spinner = true;


    },

    seriesMedicionesOrpOzonizado: function (valor) {

      

      if (Array.isArray(valor)) {
        this.fillSeries(valor);
      } else {
        console.error("seriesMediciones debe ser un arreglo. Valor proporcionado:", valor);

      }
    },
  },




  methods: {
 
    fillSeries(medOxigenado) {

      if (medOxigenado == null) {
        this.labelErr = "no se pudieron leer datos";
        this.spinner = false;
        return false;
      }

      this.chartOptions.series = [];
      this.arrayAllVal = [];
      let serieOxigenado = this.procesaSerie(medOxigenado)
      let serieNatural = this.procesaSerie(this.seriesMedicionesOrpNatural);




      let series = [];
      for (const value of serieNatural) {
        series.push(value)
      }
      for (const value of serieOxigenado) {
        series.push(value);
      }
     
      this.chartOptions.series = series;

      this.spinner = false;
      this.$emit("loadMultiplesUnidades", true);


      if (this.tieneMediciones == false) {
        this.chartOptions.yAxis.max = 200;
        this.chartOptions.yAxis.min = 0;
      } else {

     
        this.valorMinY0 = Math.min(...this.arrayAllVal);
        this.valorMaxY0 = Math.max(...this.arrayAllVal);
        let nuevoValorMin = this.valorMinY0;
        let nuevoValorMax = this.valorMaxY0;
        if(nuevoValorMin >=50){
            nuevoValorMin = nuevoValorMin - 20;
        }else{
                if(nuevoValorMin >=40){
                   nuevoValorMin = 40;
                } else{
                    nuevoValorMin =30
                }
        }


        this.chartOptions.yAxis.max = nuevoValorMax;
        this.chartOptions.yAxis.min = nuevoValorMin;
        this.chartOptions = {
          ...this.chartOptions,
          xaxis: { categories: [] },
          yaxis: [
            {
              ...this.chartOptions.yaxis,

              max: this.nuevoValorMax,
              min: this.nuevoValorMin,

            }
          ],

        };
      }

     

    },


    showModalHelp() {

      this.showModal = true;
    },
    closeModalHelp() {

      this.showModal = false;
    },
    loadMapa(f) {

      this.$emit("loadMapa", f);
    },


    procesaSerie(nuevoValor) {
      nuevoValor.forEach(obj => {




        let zones_oxigeno = []
        let ultimo_injection_tag = '';
        let index = 0;
        obj.data = obj.data.map(([timestamp, cantidad, injection]) => {


          if (index == 0) {

            ultimo_injection_tag = injection

          } else {

            if (injection !== ultimo_injection_tag) {

              zones_oxigeno.push({
                tag: injection,
                value: timestamp,
                color: ultimo_injection_tag == false && injection == true ? 'cyan' : '',
              })

            } else {
              zones_oxigeno.push({
                tag: injection,
                value: timestamp,
                color: ultimo_injection_tag == true ? 'cyan' : '',
              })


            }

            ultimo_injection_tag = injection;

          }




          cantidad = cantidad == null ? 0 : cantidad;
          if (cantidad > 0)
          {
              this.tieneMediciones = true;
          this.arrayAllVal.push(cantidad);
              index++;

            } 

       
          return cantidad === 0 ? [timestamp, null, injection] : [timestamp, cantidad, injection];
        })

        obj.zones = zones_oxigeno;
        obj.zoneAxis = 'x';
        obj.yAxis = 0;
      });

      return nuevoValor;
    }
    /////////////

  },

  mounted() {
 
    this.natural = false;
    this.oxigenado = true;
   this.spinner = this.mostrarSpinner;


    const setpoints = this.$store.state.login.userLogin.info.default_setpoints;
    const resultado = setpoints.find(item => item.idPar === 4);
   
    this.tipoMedicion = resultado ? resultado.descripcion : null;
    this.umeMedicion   =resultado ? resultado.unMedida : null;
  

    this.natural = false;
    this.oxigenado = true;

 
    this.chartOptions.yAxis.title.text = `${this.tipoMedicion} ${this.umeMedicion}` ;

   const options_lang=  i18n.global.locale.value ==='es' ?  this.lang_esp : this.lang_eng ;
    Highcharts.setOptions({lang:options_lang});

  },
};



</script>
